exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-0d905ece] {\r\n    font-weight: 300;\n}\r\n", ""]);

// exports
